/**
 * Returns string where all dots are changed to commas
 *
 * @param {(string|number)} string
 * @returns {string}
 */
export default string => `${string}`.replace(/\./g, ',');
